import { render } from "./InvitationAcceptance.vue?vue&type=template&id=77c2ce86&scoped=true"
import script from "./InvitationAcceptance.vue?vue&type=script&lang=js"
export * from "./InvitationAcceptance.vue?vue&type=script&lang=js"

import "./InvitationAcceptance.vue?vue&type=style&index=0&id=77c2ce86&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c2ce86"]])

export default __exports__